<ui-kit-modal [size]="SizeScheme.Medium" (closeClick)="onCloseDialog($event)">
  <ng-template uiKitModalTitle>{{ documentsHeading }}</ng-template>

  <ng-template uiKitModalContent>
    <app-documents-viewer [documents]="documents"></app-documents-viewer>
  </ng-template>

  <ng-template uiKitModalCloseButton>
    <button uiKitButton color="white">Close</button>
  </ng-template>
</ui-kit-modal>
